var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map",staticClass:"tdt-map",staticStyle:{"width":"100%","height":"800px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }